import { render } from "./MinistryExecutionList.vue?vue&type=template&id=1ba7d238&scoped=true"
import script from "./MinistryExecutionList.vue?vue&type=script&lang=js"
export * from "./MinistryExecutionList.vue?vue&type=script&lang=js"

import "./MinistryExecutionList.vue?vue&type=style&index=0&id=1ba7d238&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba7d238"]])

export default __exports__